"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class PlaybookModel {
    constructor(json = {}) {
        Object.assign(this, json);
        if (json.taskTemplates) {
            this.taskTemplates = this.parseJsonTaskTemplates(json.taskTemplates);
        }
    }
    parseJsonTaskTemplates(jsonTaskTemplates) {
        if (typeof jsonTaskTemplates === 'string') {
            try {
                jsonTaskTemplates = JSON.parse(jsonTaskTemplates);
            }
            catch (ex) {
                jsonTaskTemplates = [];
            }
        }
        return jsonTaskTemplates.map((taskTemplate) => new _1.TaskTemplateModel(taskTemplate));
    }
}
exports.PlaybookModel = PlaybookModel;
//# sourceMappingURL=playbook.model.js.map